import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TransferState } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessSettingsService {
  private _baseApi: string = `${environment.apiUrl}/projects/projects`;
  private _limit: number = 5;
  private _offset: number = 0;

  constructor(
    private _http: HttpClient,
    private _transferState: TransferState,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {}

  getProjects(isShowMore: boolean): Observable<any> {
    this._offset = isShowMore ? this._offset + this._limit : 0;

    return this._http.get(`${this._baseApi}_with_members/`, {
      params: {
        limit: this._limit,
        offset: this._offset,
      },
    });
  }

  getMembers(id: number): Observable<any> {
    return this._http.get(`${this._baseApi}/${id}/members/`);
  }

  removeMember(id: number): Observable<any> {
    return this._http.delete(`${this._baseApi}/members/${id}/`);
  }

  changeStatusMember(id: number, active: boolean): Observable<any> {
    return this._http.put(`${this._baseApi}/members/${id}/`, {
      active,
    });
  }

  inviteMembers(emails: { email: string }[], idProject: number): Observable<any> {
    return this._http.post(`${this._baseApi}/${idProject}/invite_members/`, emails);
  }
}
